
// window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');


// Check the opt in box on subscribe to download forms by default
$('document').ready(() => {
    $('input.std-gdpr-agreement').each(function () {
        $(this).attr('checked','checked')
    })

})

require('bootstrap-sass');





// WEBPACK FOOTER //
// ./src/js/bootstrap.js